export default __webpack_public_path__ + "static/consumer-quiz-up-92d3ebb96b7761a2383421ea0129e160.gif";